<button mat-icon-button>
    <mat-icon>done_all</mat-icon>
</button>
